module.exports = __webpack_public_path__ + "img/answer-c1-4.efffce5a.png";